import React from 'react';
import { ShoppingCart, DollarSign, Package } from 'lucide-react';
import { formatWholeNumber, formatNumber } from '../../../../../../../core/utils/campaigns';
import KpiBar, { KpiCard } from '../../../../../../shared/designSystem/components/KpiBar';

// Same numeric computation as before — groupBy-ORDER_ID count for Transactions,
// sum(PRICE * QUANTITY) for Sub Total, sum(QUANTITY) for Quantity. Only the
// chrome changes: shared v2 `KpiBar` + `KpiCard` primitives (icon tiles +
// mono eyebrows), identical to BasketItemsPerformance in the V2 tab now that
// the local `KpiCard` copies have been collapsed into one import.

const DetailsBar = ({ data = [], aggregatedData }) => {
  const transactions = aggregatedData ? Object.keys(aggregatedData).length : 0;

  // Preserved from V1 — guard against NaN leaking into the display.
  const checkIfValidNumber = (number) =>
    typeof number === 'number' && !isNaN(number) ? number : 0;

  const revenue = data.reduce(
    (acc, item) =>
      acc +
      parseFloat(checkIfValidNumber(item.PRICE)) * parseInt(checkIfValidNumber(item.QUANTITY)),
    0
  );

  const quantity = data.reduce(
    (acc, item) => acc + parseInt(checkIfValidNumber(item.QUANTITY)),
    0
  );

  return (
    <KpiBar>
      <KpiCard
        icon={<ShoppingCart size={16} />}
        iconTint="primary"
        label="Transactions"
        value={formatWholeNumber(transactions)}
      />
      <KpiCard
        icon={<DollarSign size={16} />}
        iconTint="emerald"
        label="Sub Total"
        labelTooltip="Revenue before taxes, shipping and promotions"
        value={`$${formatNumber(revenue)}`}
      />
      <KpiCard
        icon={<Package size={16} />}
        iconTint="indigo"
        label="Quantity"
        labelTooltip="Total number of product items within all selected transactions"
        value={formatWholeNumber(quantity)}
      />
    </KpiBar>
  );
};

export default DetailsBar;
